import { db } from '@/shared/services/firebase'

import {
  isPhoneNumber, isEmail, isFullName, isNonEmptyText,
} from '@hw-core/utils'
import { FIELD } from '../../../constants'
import { extractInput } from '../utils'

// utils
const extractStartAndEndCode = input => {
  const strlength = input.length
  const lastStrPos = strlength - 1
  const strFrontCode = input.slice(0, lastStrPos) // eg. 'Juka' -> 'Juk'
  const strEndCode = input.slice(lastStrPos, strlength) // eg. 'Juka' -> 'a'
  const startcode = input
  const endcode = strFrontCode + String.fromCharCode(strEndCode.charCodeAt(0) + 1)
  return [startcode, endcode]
}

const defineSearchFields = input => {
  let fields = [FIELD.FULL_NAME]
  if (isPhoneNumber(input)) {
    fields = [FIELD.MOBILE, FIELD.EMAIL]
  } else if (isEmail(input)) {
    fields = [FIELD.EMAIL]
  } else if (isFullName(input)) {
    fields = [FIELD.FULL_NAME]
  } else {
    fields = [FIELD.FULL_NAME, FIELD.LAST_NAME, FIELD.EMAIL]
  }
  return fields
}

// build queries
const buildNonAdminQuery = () => db
  .collection('users')
  .where('isAdmin', '==', false) // user is not admin: hr, dev team etc. or only employees

const buildSearchByStringQuery = (_input, field) => {
  const input = _input.toLowerCase() // need to convert to lowercase!!!
  const [startcode, endcode] = extractStartAndEndCode(input)
  return buildNonAdminQuery()
    .where(field, '>=', startcode) // search by alphabetically order, from left to right
    .where(field, '<', endcode)
}

const buildQueriesByInput = input => {
  const fields = defineSearchFields(input)
  return fields.map(field => ({ query: buildSearchByStringQuery(input, field), field }))
}

const buildQueriesFromFilters = (queryParams, buildQueryByFilters, augmentQuery) => {
  let query = buildQueryByFilters(buildNonAdminQuery(), queryParams)
  query = augmentQuery(query, queryParams)
  return [query]
}

const augmentQueries = (queries, queryParams, augmentQuery) => queries.map(queryObj => augmentQuery(queryObj.query, queryParams, queryObj?.field))

const buildQueriesFromInput = (queryParams, augmentQuery) => {
  const input = extractInput(queryParams)
  let queries = buildQueriesByInput(input)
  queries = augmentQueries(queries, queryParams, augmentQuery)
  return queries
}

const buildQueries = (queryParams, buildQueryByFilters, augmentQuery) => {
  const input = extractInput(queryParams)
  const queries = isNonEmptyText(input) ? buildQueriesFromInput(queryParams, augmentQuery) : buildQueriesFromFilters(queryParams, buildQueryByFilters, augmentQuery)
  return queries
}

async function executeQueries(queries) {
  try {
    const promises = queries.map(query => query.get())
    const snapshots = await Promise.all(promises)
    const res = Object.values(snapshots.reduce((acc, snapshot) => { // merge snapshots' documents without duplications
      const { docs } = snapshot
      const docsDict = docs.reduce((dict, doc) => {
        // eslint-disable-next-line no-param-reassign
        dict[doc.id] = { ...doc.data(), id: doc.id }
        return dict
      }, {})
      return { ...acc, ...docsDict }
    }, {}))
    return res
  } catch (error) {
    throw new Error('Error executeQuery', error) // TODO refactor to common handler
  }
}

const get = async (queryParams, buildQueryByFilters, augmentQuery) => {
  const queries = buildQueries(queryParams, buildQueryByFilters, augmentQuery)
  const data = await executeQueries(queries)
  return data
}

export {
  // eslint-disable-next-line import/prefer-default-export
  get,
}
